import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

export default function GrowthContact() {
  return (
    <section id="contact" className="relative py-32 md:py-48 bg-accent overflow-hidden">
      <div className="absolute inset-0 bg-[url('/assets/bg-noise.png')] opacity-10 mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-accent/80 via-transparent to-accent pointer-events-none" />

      <div className="container relative z-10">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-sm font-bold text-white/80 uppercase tracking-[0.2em] mb-8">Get in Touch</h2>
          <h3 className="text-5xl md:text-8xl font-bold font-heading text-white mb-12 tracking-tight uppercase leading-[0.9]">
            Ready to <br /> <span className="text-white/90">Scale?</span>
          </h3>
          <p className="text-xl md:text-2xl text-slate-200 mb-16 max-w-2xl mx-auto font-light leading-relaxed">
            Let's talk about your acquisition goals. PPC, social, email, CRO — we'll build a growth system that compounds.
          </p>

          <Link
            to="/new-project"
            className="inline-flex items-center gap-3 group px-12 py-5 text-xl font-bold bg-white text-accent hover:bg-white/90 rounded-full shadow-[0_0_40px_-10px_rgba(255,255,255,0.3)] hover:shadow-[0_0_60px_-10px_rgba(255,255,255,0.5)] transition-all duration-500"
          >
            Start a growth project
            <ArrowRight className="h-6 w-6 group-hover:translate-x-2 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  )
}
